// extracted by mini-css-extract-plugin
module.exports =  {"textarea-wrapper":"Textarea-b8xX__textarea-wrapper","textarea-wrapper--has-label":"Textarea-vC3R__textarea-wrapper--has-label","dummy":"Textarea-fzkd__dummy"};